import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { StaticViewDataService } from '../../service/static-view-data-service.service';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { GoogleAnalyticsService } from '../../service/google-analytics.service';
import Editor from "../../../assets/js/ckeditor";
import { environment } from '../../../environments/environment';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { saveAs } from 'file-saver';
export class AllWireFeedListingComponent {
    constructor(config, restService, http, snotify, _http, sharedService, router, sanitizer, gaService) {
        this.config = config;
        this.restService = restService;
        this.http = http;
        this.snotify = snotify;
        this._http = _http;
        this.sharedService = sharedService;
        this.router = router;
        this.sanitizer = sanitizer;
        this.gaService = gaService;
        this.customOptions = {
            loop: true,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            dots: false,
            autoWidth: true,
            navSpeed: 700,
            // navText: ['', ''],
            responsive: {},
            nav: true,
            navText: [],
        };
        this.getDataUrl = '';
        this.metaDataUrl = '';
        this.all_element_api = StaticDataService.element_byids_api;
        this.page_id = StaticDataService.story_page_id;
        this.socketsAllowed = [];
        this.filterList = [];
        this.facets = null;
        this.pageNum = 0;
        this.listArray = [];
        this.listIdArray = [];
        this.noresults = false;
        this.pageSize = 50;
        this.pageSizeArray = [50, 100, 150, 200];
        this.sortByValueOf = null;
        this.exactMatch = false;
        this.filterUrl = {};
        this.fields = '';
        this.initialUrl = '';
        this.latestUrl = '';
        this.callFail = false;
        this.pages = 0;
        this.totalRecords = 0;
        this.str = '';
        this.searchFocus = false;
        this.showMore = false;
        this.headerList = [];
        this.monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        this.accessDenied = false;
        this.timings = {
            constr: 0,
            onin: 0,
            resp: 0,
            list: 0,
            getEnv: 0,
            getMeta: 0
        };
        this.subject = new Subject();
        this.viewObject = null;
        this.domain = null;
        this.agencyHide = '';
        this.wireImageUrl = this.config.get('product').wireImageUrl;
        this.showLoader = false;
        this.wireGetUrl = '';
        this.wirePutUrl = '';
        this.openWirePreview = false;
        this.openCompetetionPreview = false;
        this.wirePreviewStory = null;
        this.placeholder = '';
        this.domainConfig = null;
        this.suggestionDataUrl = '';
        this.showSuggestionBox = false;
        this.listSuggestionArray = [];
        this.valueChangeEvent = true;
        this.arrowkeyLocation = 0;
        this.wireContent = null;
        this.disabledAgencyFeeds = [];
        this.wireImageDisplayUrl = this.config.get('product').wireImageDisplayUrl;
        this.enabledHindiAgencyFeeds = [];
        this.enabledAgencyFeeds = [];
        this.enabledAffiliateFeeds = [];
        this.setFeedsName = '';
        this.ckEditor2 = Editor;
        this.trustedHTML = null;
        this.galleryAccessDenied = false;
        this.openAIGalleryView = false;
        this.videoConvertorReqBody = {
            "logoUrl": '',
            "audioUrl": '',
            "storyId": '',
            "domainId": '',
            "content": {}
        };
        this.isVideoWebStoryEnabled = false;
        this.selectedService = 'azure';
        this.dataInsertion = (data) => {
            let results = [];
            if (this.pageId === 'competetionData') {
                results = data['data'];
            }
            else {
                results = data['content'];
            }
            this.listArray = [];
            this.listIdArray = [];
            if (this.pageId === 'LHphotogalleryFeed') {
                if (data) {
                    this.listArray = data;
                    this.noresults = false;
                }
                else {
                    this.noresults = true;
                }
            }
            else {
                if (results && results.length > 0) {
                    this.listArray = results;
                    this.listIdArray = results.map(e => e.id);
                    this.noresults = false;
                }
                else {
                    this.noresults = true;
                }
            }
        };
        this.timings.constr = performance.now();
        console.log('constructor => 0');
        this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
        this.disabledAgencyFeeds = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['agencyFeeds']
            && this.domainConfig['config']['agencyFeeds']['filterFieldToDisable']) ? this.domainConfig['config']['agencyFeeds']['filterFieldToDisable'].split(',') : [];
        this.enabledHindiAgencyFeeds = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['hindiFeeds']
            && this.domainConfig['config']['hindiFeeds']['enabledAgencies']) ? this.domainConfig['config']['hindiFeeds']['enabledAgencies'].split(',') : [];
        this.enabledAgencyFeeds = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['agencyFeeds']
            && this.domainConfig['config']['agencyFeeds']['enabledAgencies']) ? this.domainConfig['config']['agencyFeeds']['enabledAgencies'].split(',') : [];
        this.enabledAffiliateFeeds = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['affiliateFeeds']
            && this.domainConfig['config']['affiliateFeeds']['enabledAgencies']) ? this.domainConfig['config']['affiliateFeeds']['enabledAgencies'].split(',') : [];
        this.enableStoryFeed = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['feeds']
            && this.domainConfig['config']['feeds']['enableStoryFeed']) === 'true';
        this.disableFeedsDomain = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['feeds']
            && this.domainConfig['config']['feeds']['disableFeedsDomain']);
        this.printFeedForLH = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['feeds']
            && this.domainConfig['config']['feeds']['printFeedForLH']);
        this.aiWebStory = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['feeds']
            && this.domainConfig['config']['feeds']['aiWebStory']);
        this.domainWiseAgency = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['feeds'] && this.domainConfig['config']['feeds']['domainWiseAgency'] ? this.domainConfig['config']['feeds']['domainWiseAgency'] : '';
        this.isVideoWebStoryEnabled = this.domainConfig['config'] && this.domainConfig['config']['feeds'] && this.domainConfig['config']['feeds']['showVideoWebStory'] ? this.domainConfig['config']['feeds']['showVideoWebStory'] : false;
    }
    getDomainConfig(currentDomainConfig) {
        this.domainConfig = currentDomainConfig;
    }
    ngOnInit() {
        console.log(this.pageId);
        switch (this.pageId) {
            case 'agencyFeed':
                this.viewObject = StaticViewDataService.AgencyFeed_listing_View;
                this.placeholder = 'Search Wire Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Agency Feed';
                break;
            case 'twitterFeed':
                this.viewObject = StaticViewDataService.TwitterFeed_listing_View;
                this.placeholder = 'Search Twitter...';
                this.getDataUrl = this.config.get('product').utilUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'TwitterFeed';
                break;
            case 'printFeed':
                this.viewObject = this.printFeedForLH ? StaticViewDataService.LH_PrintFeed_listing_View : StaticViewDataService.PrintFeed_listing_View;
                this.placeholder = 'Search Print Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Print Feed';
                break;
            case 'currentEconomistFeed':
                this.viewObject = StaticViewDataService.EconomistFeedCurrent_listing_View;
                this.placeholder = 'Search Economist Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Economist Feed';
                break;
            case 'archivedEconomistFeed':
                this.viewObject = StaticViewDataService.EconomistFeedArchive_listing_View;
                this.placeholder = 'Search Economist Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Economist Feed';
                break;
            case 'printEconomistFeed':
                this.viewObject = StaticViewDataService.EconomistFeed_listing_View;
                this.placeholder = 'Search Economist Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Economist Feed';
                break;
            case 'wsjFeed':
                this.viewObject = StaticViewDataService.wsjFeed_listing_View;
                this.placeholder = 'Search WSJ Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'WSJ Feed';
                break;
            case 'competitionFeed':
                this.viewObject = StaticViewDataService.CompetitionFeed_listing_View;
                this.placeholder = 'Search Competition Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Competition Feed';
                break;
            case 'photogalleryFeed':
                this.viewObject = StaticViewDataService.photogalleryFeed_listing_View;
                this.placeholder = 'Search Photo Gallery Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Photogallery Feed';
                break;
            case 'webStoryFeed':
                this.viewObject = StaticViewDataService.webStoryFeed_listing_View;
                this.placeholder = 'Search Web Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Photogallery Feed';
                break;
            case 'AIgalleryFeed':
                this.viewObject = StaticViewDataService.AIgalleryFeed_listing_View;
                this.placeholder = 'Search AI Gallery Feed...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'AI Gallery Feed';
                break;
            case 'storyFeed':
                this.viewObject = StaticViewDataService.storyFeed_listing_View;
                this.placeholder = 'Search Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Story Feed';
                break;
            case 'translationFeedHT':
                this.viewObject = StaticViewDataService.translaationFeed_listing_View;
                this.placeholder = 'Search HT Translated Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'HT Translation Feed';
                break;
            case 'translationFeedLM':
                this.viewObject = StaticViewDataService.translaationFeed_listing_View;
                this.placeholder = 'Search LM Translated Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'LM Translation Feed';
                break;
            case 'translationFeedLM':
                this.viewObject = StaticViewDataService.translaationFeed_listing_View;
                this.placeholder = 'Search LM Translated Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'LM Translation Feed';
                break;
            case 'translationFeedBangla':
                this.viewObject = StaticViewDataService.translaationFeed_listing_View;
                this.placeholder = 'Search Bangla Translated Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'LM Translation Feed';
                break;
            case 'translationFeedTamil':
                this.viewObject = StaticViewDataService.translaationFeed_listing_View;
                this.placeholder = 'Search Tamil Translated Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'LM Translation Feed';
                break;
            case 'translationFeedTelegu':
                this.viewObject = StaticViewDataService.translaationFeed_listing_View;
                this.placeholder = 'Search Telegu Translated Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'LM Translation Feed';
                break;
            case 'translationFeedKannada':
                this.viewObject = StaticViewDataService.translaationFeed_listing_View;
                this.placeholder = 'Search Kannada Translated Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'LM Translation Feed';
                break;
            case 'translationFeedMarathi':
                this.viewObject = StaticViewDataService.translaationFeed_listing_View;
                this.placeholder = 'Search Marathi Translated Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'LM Translation Feed';
                break;
            case 'LHphotogalleryFeed':
                this.viewObject = StaticViewDataService.photogalleryFeed_listing_View;
                this.placeholder = 'Search LH Photo Gallery Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + '/api/cms/photoGallery';
                // this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'LHphotogallery Feed';
                break;
            case 'affiliateFeed':
                this.viewObject = StaticViewDataService.AffiliateFeed_listing_View;
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.placeholder = 'Search Affiliate Stories...';
                this.setFeedsName = 'Affiliate Feed';
                break;
            case 'hindiFeed':
                this.viewObject = StaticViewDataService.HindiFeed_listing_View;
                this.placeholder = 'Search Hindi Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Hindi Feed';
                break;
            case 'webstoryFeed':
                this.viewObject = StaticViewDataService.webstoryFeed_listing_View;
                this.placeholder = 'Search Web Stories...';
                this.getDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Web story Feed';
                break;
            case 'competetionData':
                this.viewObject = StaticViewDataService.competetionData_listing_View;
                this.placeholder = 'Search Competition Stories...';
                this.getDataUrl = this.config.get('product').utilUrl + this.viewObject.urls.listing;
                this.setFeedsName = 'Competition Data';
        }
        this.domain = sessionStorage.getItem(StaticDataService.domainLiteral);
        this.timings.onin = performance.now();
        console.log('oninit => ', performance.now() - this.timings.constr);
        if (this.pageId == 'twitterFeed' || this.pageId == 'competetionData')
            this.metaDataUrl = this.config.get('product').utilUrl + this.viewObject.urls.meta;
        else
            this.metaDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.meta;
        this.socketsAllowed = this.viewObject.socketCodes;
        const filters = this.viewObject.filters;
        this.filterList = this.sharedService.getUpdatedFilters(filters);
        this.fields = this.viewObject.fields;
        this.headerList = this.viewObject.headers;
        this.routeLinkForList = this.viewObject.list_router;
        this.wireGetUrl = this.config.get('product').baseUrl + this.viewObject.urls.wireGet;
        this.wirePutUrl = this.config.get('product').baseUrl + this.viewObject.urls.wirePut;
        this.suggestionDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.suggestion;
        this.timings.getEnv = performance.now();
        console.log('getEnv => ', performance.now() - this.timings.onin);
        // if (localStorage.getItem('domainConfig')) {
        //   const allDomains = JSON.parse(localStorage.getItem('domainConfig'));
        //   const domains = Object.keys(allDomains);
        //   domains.forEach(e => {
        //     if (allDomains[e]['config']['jsonfeed']['print_feed']) {
        //       debugger;
        //       this.agencyHide = this.agencyHide + ',agency!' + allDomains[e]['config']['jsonfeed']['print_feed'];
        //     }
        //   });
        // }
        if (this.searchInput) {
            this.searchInput.nativeElement.focus();
        }
        if (this.viewObject.sortBy) {
            this.sortByValueOf = this.viewObject.sortBy;
        }
        if (this.metaDataUrl && this.metaDataUrl.trim() !== '') {
            this.restService.http_get(this.metaDataUrl)
                .subscribe(data => {
                this.facets = Object.assign({}, data, this.facets);
                if (this.pageId == 'storyFeed') {
                    this.facets['sections'] = {};
                }
            });
        }
        this.timings.getMeta = performance.now();
        console.log('getmeta => ', performance.now() - this.timings.getEnv);
        this.getDefaultList(0, this.dataInsertion);
        this.showSuggestionBox = false;
        this.subject
            .pipe(debounceTime(800), distinctUntilChanged())
            .subscribe(result => {
            // this.str = result;
            this.getautoSuggestion(result, data => {
                if (this.pageId !== 'competetionData') {
                    this.listSuggestionArray = [];
                    // console.log(data);
                    const dataSuggestion = data;
                    if (dataSuggestion && dataSuggestion.length > 0) {
                        for (let i = 0; i < dataSuggestion.length; i++) {
                            this.listSuggestionArray.push(dataSuggestion[i]);
                        }
                        this.showSuggestionBox = true;
                    }
                    else {
                        this.showSuggestionBox = false;
                    }
                }
            });
        });
        this.sharedService.getData().subscribe(x => {
            if (x === 'key27') {
                if (this.openWirePreview || this.openCompetetionPreview) {
                    this.closePreview();
                }
            }
        });
        if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['socket'] && this.domainConfig['config']['socket']['enableSocket'] && this.domainConfig['config']['socket']['enableSocket'] === 'true') {
            this.initializeWebSocketConnection();
        }
    }
    prevSlide(owlCarousel, index, item) {
        item.index = owlCarousel.slidesOutputData.startPosition + 1;
        owlCarousel.prev();
    }
    nextSlide(owlCarousel, index, item) {
        item.index = owlCarousel.slidesOutputData.startPosition + 1;
        owlCarousel.next();
    }
    getautoSuggestion(query, callback) {
        if (query && query.trim() !== '') {
            const tempQuery = query;
            query = query.split(' ');
            query = query[(query.length - 1)];
            if (query && query.length > 2 && this.valueChangeEvent) {
                this.showSuggestionBox = false;
                const url = this.suggestionDataUrl + '?text=' + StaticDataService.encodeSpecialChar(tempQuery);
                this.restService.http_get(url)
                    .subscribe(data => {
                    callback(data);
                }, error => {
                    // console.log(error);
                });
            }
        }
        else {
            this.getDefaultList(0, this.dataInsertion);
            this.showSuggestionBox = false;
        }
    }
    removeHTML(text) {
        return text.replace(/<[^>]*>/g, '\n');
    }
    removeHTMLpara(text) {
        let data = text.replace(/<[^>]*>/g, '\n')
            .replace('&nbsp;', ' ');
        return data;
    }
    selectLogo(logoPath) {
        this.videoConvertorReqBody.logoUrl = logoPath;
        this.logoList.forEach(e => {
            if (e['path'] == logoPath) {
                this.logoUrl = e['url'];
            }
        });
    }
    selectAudio(audio) {
        this.videoConvertorReqBody.audioUrl = audio;
        this.audioList.forEach(e => {
            if (e['path'] == audio) {
                this.audioUrl = e['url'];
            }
        });
    }
    getsearchResults(item) {
        this.searchResults(item, 0, data => {
            this.str = item;
            this.pageNum = 0;
            this.dataInsertion(data);
            if (data && data['content'] && data['content'].length > 0) {
                this.showSuggestionBox = false;
                this.valueChangeEvent = false;
            }
            else {
                this.showSuggestionBox = true;
                this.valueChangeEvent = true;
            }
        });
    }
    onKeydown(event, input) {
        if (this.pageId !== 'competetionData') {
            console.log(event.keyCode);
            // console.log(event.keyCode, this.arrowkeyLocation, this.listSuggestionArray);
            if (event.key === 'Enter') {
                this.getsearchResults(this.str);
                this.showSuggestionBox = false;
            }
            else if (event.keyCode === 32) {
                this.getautoSuggestion(this.str, data => {
                    this.listSuggestionArray = [];
                    const dataSuggestion = data;
                    if (dataSuggestion && dataSuggestion.length > 0) {
                        for (let i = 0; i < dataSuggestion.length; i++) {
                            this.listSuggestionArray.push(dataSuggestion[i]);
                        }
                        this.showSuggestionBox = true;
                    }
                    else {
                        this.showSuggestionBox = false;
                    }
                });
            }
            else if (event.keyCode === 40 && this.arrowkeyLocation < this.listSuggestionArray.length - 1) {
                this.valueChangeEvent = false;
                this.showSuggestionBox = true;
                this.arrowkeyLocation++;
                this.str = this.listSuggestionArray[this.arrowkeyLocation];
            }
            else if (event.keyCode === 38 && this.arrowkeyLocation > 0) {
                this.valueChangeEvent = false;
                this.showSuggestionBox = true;
                this.arrowkeyLocation--;
                this.str = this.listSuggestionArray[this.arrowkeyLocation];
            }
            else if (event.keyCode === 86 || event.keyCode === 91 || event.keyCode === 17) {
                this.valueChangeEvent = false;
            }
            else {
                this.subject.next(input.value);
                this.valueChangeEvent = true;
                this.arrowkeyLocation = 0;
            }
        }
        else {
            if (event.key === 'Enter') {
                this.getsearchResults(this.str);
                this.showSuggestionBox = false;
            }
        }
        return true;
    }
    extractDomain(url) {
        const match = url.match(/:\/\/(www[0-9]?\.)?([^/:]+)/i);
        if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
            const domainParts = match[2].split('.');
            if (domainParts.length > 1) {
                return domainParts[0]; // Return the first part of the domain
            }
            else {
                return match[2];
            }
        }
        else {
            return url;
        }
    }
    routeToVideoCms(item) {
        this.showLoader = true;
        this.router.navigate(['/dash/video-cms'], { queryParams: { 'aiVideoUrl': item.aiVideoUrl }, skipLocationChange: true });
    }
    initializeWebSocketConnection() {
        const ws = new SockJS(this.config.get('product').socketUrl
            + '?access_token='
            + JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).access_token);
        this.stompClient = Stomp.over(ws);
        this.stompClient.debug = false;
        const self = this;
        const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
        this.stompClient.connect({}, function (frame) {
            if (self.socketsAllowed.indexOf(3) > -1) {
                console.log('wire pick socket online!');
                self.stompClient.subscribe('/topic/feed-pick-' + domain, (message) => {
                    const bodyObj = JSON.parse(message.body);
                    const j = self.listIdArray.indexOf(bodyObj.id);
                    if ((j > -1) && (self.listArray[j].id === bodyObj.id) && (self.initialUrl === self.latestUrl)) {
                        self.listArray[j] = bodyObj;
                        if (self.wirePreviewStory && (bodyObj.id === self.wirePreviewStory.id)) {
                            self.wirePreviewStory = bodyObj;
                        }
                    }
                }, err => {
                    // console.log('sorry could not subscribe to socket');
                });
            }
            if (self.socketsAllowed.indexOf(4) > -1) {
                console.log('wire publish socket online!');
                self.stompClient.subscribe('/topic/feed-publish-' + domain, (message) => {
                    const bodyObj = JSON.parse(message.body);
                    const j = self.listIdArray.indexOf(bodyObj.id);
                    if ((j > -1) && (self.listArray[j].id === bodyObj.id) && (self.initialUrl === self.latestUrl)) {
                        self.listArray[j] = bodyObj;
                        if (self.wirePreviewStory && (bodyObj.id === self.wirePreviewStory.id)) {
                            self.wirePreviewStory = bodyObj;
                        }
                    }
                }, err => {
                    // console.log('sorry could not subscribe to socket');
                });
            }
        }, err => {
            console.log(err);
        });
    }
    searchResults(query, pageNum, callback) {
        if (query && query.trim() !== '') {
            let url = this.getDataUrl + '?page=' + pageNum + '&size=' + this.pageSize;
            if (this.pageId !== 'LHphotogalleryFeed') {
                if (this.sortByValueOf) {
                    url += '&sort=' + this.sortByValueOf + ',desc';
                }
                url += this.fields;
                if (this.exactMatch) {
                    url += '&exact=true';
                }
                url += '&search=,';
                if (this.pageId === 'photogalleryFeed') {
                    url += "type:gallery,domainId!" + this.domainConfig.domainId;
                }
                if (this.pageId === 'webStoryFeed') {
                    url += "type:web-story,domainId!606ef2a063b8119169fa6a14,metadata.status:PUBLISHED";
                }
                if (this.pageId === 'storyFeed') {
                    url += "type:story";
                }
                if (this.pageId === 'webstoryFeed') {
                    url += "metadata.status:PUBLISHED,type:web-story,domainId!" + this.domainConfig.domainId;
                }
            }
            if (this.filterUrl) {
                for (const filter in this.filterUrl) {
                    if (filter) {
                        url += this.filterUrl[filter];
                    }
                }
            }
            switch (this.pageId) {
                case 'agencyFeed':
                    // if(this.disabledAgencyFeeds.indexOf('ht_syndication') === -1)
                    // {
                    //   url += ',agency!mint_print,agency!ht_print-prepub;digital_ht;ht_print';
                    // } else {
                    //   url += ',agency!ht_syndication,agency!ht_print-prepub;mint_print;digital_ht;ht_print';
                    // }
                    if (this.enabledAgencyFeeds && this.enabledAgencyFeeds.length === 0) {
                        url += ',agency!mint_print,agency!ht_print-prepub;digital_ht;ht_print';
                    }
                    else {
                        url += ',agency:';
                        for (var i = 0; i < this.enabledAgencyFeeds.length; i++) {
                            url += this.enabledAgencyFeeds[i] + ';';
                        }
                        url = url.slice(0, -1);
                    }
                    url += ',source!pulse';
                    break;
                case 'printFeed':
                    if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['jsonfeed']
                        && this.domainConfig['config']['jsonfeed']['print_feed']) {
                        url += ',agency:' + this.domainConfig['config']['jsonfeed']['print_feed'];
                    }
                    else {
                        if (this.printFeedForLH) {
                            url += ',agency:' + this.domainWiseAgency;
                        }
                        else {
                            url += ',agency:mint_print';
                        }
                    }
                    url += ',source!pulse';
                    break;
                case 'currentEconomistFeed':
                    if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['jsonfeed']
                        && this.domainConfig['config']['jsonfeed']['economist_feed']) {
                        url += ',agency:' + this.domainConfig['config']['jsonfeed']['economist_feed'];
                    }
                    else {
                        url += ',agency:Economist,printStory:false';
                    }
                    url += ',issueDate>' + ((new Date().getTime()) - (60 * 24 * 60 * 60 * 1000)) + ',issueDate<' + (new Date().getTime()) + ',agency:Economist,printStory:false';
                    url += ',source!pulse';
                    break;
                case 'archivedEconomistFeed':
                    if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['jsonfeed']
                        && this.domainConfig['config']['jsonfeed']['economist_feed']) {
                        url += ',agency:' + this.domainConfig['config']['jsonfeed']['economist_feed'];
                    }
                    else {
                        url += ',agency:Economist,printStory:false';
                    }
                    url += ',issueDate<' + ((new Date().getTime()) - (60 * 24 * 60 * 60 * 1000)) + ',agency:Economist,printStory:false';
                    url += ',source!pulse';
                    break;
                case 'printEconomistFeed':
                    if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['jsonfeed']
                        && this.domainConfig['config']['jsonfeed']['economist_feed']) {
                        url += ',agency:' + this.domainConfig['config']['jsonfeed']['economist_feed'];
                    }
                    else {
                        url += ',agency:Economist,printStory:true';
                    }
                    url += ',source!pulse';
                    break;
                case 'wsjFeed':
                    if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['jsonfeed']
                        && this.domainConfig['config']['jsonfeed']['wsj_feed']) {
                        url += ',agency:' + this.domainConfig['config']['jsonfeed']['wsj_feed'];
                    }
                    else {
                        url += ',agency:WSJ';
                    }
                    url += ',source!pulse';
                    break;
                case 'competitionFeed':
                    url += ',source!pulse';
                    break;
                case 'translationFeedHT':
                    url += ',domainId:5e79e6403ea335d2b751ac21,type:story,metadata.status:PUBLISHED';
                    break;
                case 'AIgalleryFeed':
                    url += ",agency:AI";
                    console.log("AI Gallery feed", url);
                    break;
                case 'translationFeedLM':
                    url += ',domainId:5aeab8eefc36f218b0e0866b,type:story,metadata.status:PUBLISHED';
                    break;
                case 'translationFeedBangla':
                    url += ',domainId:5d957dad88ac2b284f80fa33,type:story,metadata.status:PUBLISHED';
                    break;
                case 'translationFeedTamil':
                    url += ',domainId:614b0be7d685d605a901d878,type:story,metadata.status:PUBLISHED';
                    break;
                case 'translationFeedTelegu':
                    url += ',domainId:614b0baed685d605a901d877,type:story,metadata.status:PUBLISHED';
                    break;
                case 'translationFeedMarathi':
                    url += ',domainId:614b0c8fd685d605a901d879,type:story,metadata.status:PUBLISHED';
                    break;
                case 'translationFeedKannada':
                    url += ',domainId:625415906635d51bc8bf9a50,type:story,metadata.status:PUBLISHED';
                    break;
                case 'hindiFeed':
                    // if(this.disabledAgencyFeeds.indexOf('ht_syndication') === -1)
                    // {
                    //   url += ',agency!mint_print,agency!ht_print-prepub;digital_ht;ht_print';
                    // } else {
                    //   url += ',agency!ht_syndication,agency!ht_print-prepub;mint_print;digital_ht;ht_print';
                    // }
                    if (this.enabledHindiAgencyFeeds && this.enabledHindiAgencyFeeds.length === 0) {
                        url += ',agency:Varta';
                    }
                    else {
                        url += ',agency:';
                        for (var i = 0; i < this.enabledHindiAgencyFeeds.length; i++) {
                            url += this.enabledHindiAgencyFeeds[i] + ';';
                        }
                        url = url.slice(0, -1);
                    }
                    url += ',source!pulse';
                    break;
                case 'affiliateFeed':
                    if (this.enabledAffiliateFeeds && this.enabledAffiliateFeeds.length === 0) {
                        url += ',agency:affiliate';
                    }
                    else {
                        url += ',agency:';
                        for (var i = 0; i < this.enabledAffiliateFeeds.length; i++) {
                            url += this.enabledAffiliateFeeds[i] + ';';
                        }
                        url = url.slice(0, -1);
                    }
                    url += ',source!pulse';
                    break;
            }
            const querArr = query.split(':');
            if (querArr && querArr.length > 1 && querArr[0].toUpperCase() === 'ID') {
                url += ',id:' + querArr[1].trim();
            }
            else {
                url += ',text~' + StaticDataService.encodeSpecialChar(query);
            }
            this.callFail = false;
            this.latestUrl = url;
            this.timings['firstGet'] = performance.now();
            console.log('firstGet => ', performance.now() - this.timings.getMeta);
            this.restService.http_get(url)
                .subscribe(data => {
                this.timings.resp = performance.now();
                console.log('response received => ', performance.now() - this.timings['firstGet']);
                this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
                this.totalRecords = data['totalElements'];
                if (this.pageId === 'competetionData') {
                    this.totalRecords = data['totalPages'];
                }
                this.topFunction();
                this.callFail = false;
                this.measureTime(0);
                callback(data);
            }, error => {
                this.callFail = true;
                // console.log(error);
            });
        }
        else {
            this.getDefaultList(pageNum, data => {
                callback(data);
            });
        }
    }
    copyFunction(text) {
        const selBox = document.createElement('textarea');
        selBox.value = String(text);
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.snotify.info('URL copied to Clipboard', '', this.sharedService.getConfig(false));
    }
    getDefaultList(pageNum, callback) {
        console.log(this.getDataUrl);
        let url = this.getDataUrl + '?page=' + pageNum + '&size=' + this.pageSize;
        if (this.pageId === 'photogalleryFeed' || this.pageId === 'storyFeed' || this.pageId === 'webStoryFeed') {
            this.sortByValueOf = 'lastPublishedDate';
        }
        if (this.pageId !== 'LHphotogalleryFeed') {
            if (this.sortByValueOf) {
                url += '&sort=' + this.sortByValueOf + ',desc';
            }
            url += this.fields;
            if (this.exactMatch) {
                url += '&exact=true';
            }
            url += '&search=';
            if (this.pageId === 'photogalleryFeed') {
                url += "type:gallery,domainId!" + this.domainConfig.domainId;
            }
            if (this.pageId === 'webStoryFeed') {
                url += "type:web-story,domainId!606ef2a063b8119169fa6a14,metadata.status:PUBLISHED";
            }
            if (this.pageId === 'storyFeed') {
                url += "type:story";
            }
            if (this.pageId === 'webstoryFeed') {
                url += "metadata.status:PUBLISHED,type:web-story,domainId!" + this.domainConfig.domainId;
            }
        }
        if (this.filterUrl) {
            for (const filter in this.filterUrl) {
                if (filter) {
                    url += this.filterUrl[filter];
                }
            }
        }
        switch (this.pageId) {
            case 'agencyFeed':
                // if(this.disabledAgencyFeeds.indexOf('ht_syndication') === -1)
                // {
                //   url += ',agency!mint_print,agency!ht_print-prepub;digital_ht;ht_print';
                // } else {
                //   url += ',agency!ht_syndication,agency!ht_print-prepub;mint_print;digital_ht;ht_print';
                // }
                if (this.enabledAgencyFeeds && this.enabledAgencyFeeds.length === 0) {
                    url += ',agency!mint_print,agency!ht_print-prepub;digital_ht;ht_print';
                }
                else {
                    url += ',agency:';
                    for (var i = 0; i < this.enabledAgencyFeeds.length; i++) {
                        url += this.enabledAgencyFeeds[i] + ';';
                    }
                    url = url.slice(0, -1);
                }
                url += ',source!pulse';
                break;
            case 'photogalleryFeed':
                console.log((url));
                break;
            case 'storyFeed':
                console.log((url));
                break;
            case 'LHphotogalleryFeed':
                console.log((url));
                break;
            case 'AIgalleryFeed':
                url += ",agency:AI";
                console.log("AI Gallery feed", url);
                break;
            case 'printFeed':
                if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['jsonfeed']
                    && this.domainConfig['config']['jsonfeed']['print_feed']) {
                    url += ',agency:' + this.domainConfig['config']['jsonfeed']['print_feed'];
                }
                else {
                    if (this.printFeedForLH) {
                        url += ',agency:' + this.domainWiseAgency;
                    }
                    else {
                        url += ',agency:mint_print';
                    }
                }
                url += ',source!pulse';
                break;
            case 'currentEconomistFeed':
                if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['jsonfeed']
                    && this.domainConfig['config']['jsonfeed']['economist_feed']) {
                    url += ',agency:' + this.domainConfig['config']['jsonfeed']['economist_feed'];
                }
                else {
                    if (url.includes("issueDate")) {
                        url += ',agency:Economist,printStory:false';
                    }
                    else {
                        url += ',issueDate>' + ((new Date().getTime()) - (60 * 24 * 60 * 60 * 1000)) + ',issueDate<' + (new Date().getTime()) + ',agency:Economist,printStory:false';
                    }
                }
                url += ',source!pulse';
                break;
            case 'archivedEconomistFeed':
                if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['jsonfeed']
                    && this.domainConfig['config']['jsonfeed']['economist_feed']) {
                    url += ',agency:' + this.domainConfig['config']['jsonfeed']['economist_feed'];
                }
                else {
                    if (url.includes("issueDate")) {
                        url += ',agency:Economist,printStory:false';
                    }
                    else {
                        url += ',issueDate<' + ((new Date().getTime()) - (60 * 24 * 60 * 60 * 1000)) + ',agency:Economist,printStory:false';
                    }
                }
                url += ',source!pulse';
                break;
            case 'printEconomistFeed':
                if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['jsonfeed']
                    && this.domainConfig['config']['jsonfeed']['economist_feed']) {
                    url += ',agency:' + this.domainConfig['config']['jsonfeed']['economist_feed'];
                }
                else {
                    url += ',agency:Economist,printStory:true';
                }
                url += ',source!pulse';
                break;
            case 'wsjFeed':
                if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['jsonfeed']
                    && this.domainConfig['config']['jsonfeed']['wsj_feed']) {
                    url += ',agency:' + this.domainConfig['config']['jsonfeed']['wsj_feed'];
                }
                else {
                    url += ',agency:WSJ';
                }
                url += ',source!pulse';
                break;
            case 'translationFeedHT':
                url += ',domainId:5e79e6403ea335d2b751ac21,type:story,metadata.status:PUBLISHED';
                break;
            case 'translationFeedLM':
                url += ',domainId:5aeab8eefc36f218b0e0866b,type:story,metadata.status:PUBLISHED';
                break;
            case 'translationFeedBangla':
                url += ',domainId:5d957dad88ac2b284f80fa33,type:story,metadata.status:PUBLISHED';
                break;
            case 'translationFeedTamil':
                url += ',domainId:614b0be7d685d605a901d878,type:story,metadata.status:PUBLISHED';
                break;
            case 'translationFeedTelegu':
                url += ',domainId:614b0baed685d605a901d877,type:story,metadata.status:PUBLISHED';
                break;
            case 'translationFeedMarathi':
                url += ',domainId:614b0c8fd685d605a901d879,type:story,metadata.status:PUBLISHED';
                break;
            case 'translationFeedKannada':
                url += ',domainId:625415906635d51bc8bf9a50,type:story,metadata.status:PUBLISHED';
                break;
            case 'competitionFeed':
                url += ',source:pulse';
                break;
            case 'competetionData':
                url += '';
                break;
            case 'hindiFeed':
                if (this.enabledHindiAgencyFeeds && this.enabledHindiAgencyFeeds.length === 0) {
                    url += ',agency:Varta';
                }
                else {
                    url += ',agency:';
                    for (var i = 0; i < this.enabledHindiAgencyFeeds.length; i++) {
                        url += this.enabledHindiAgencyFeeds[i] + ';';
                    }
                    url = url.slice(0, -1);
                }
                // if(this.disabledAgencyFeeds.indexOf('ht_syndication') === -1)
                // {
                //   url += ',agency:Varta;Bhasha;VARTA';
                // } else {
                //   url += ',agency:Varta;Bhasha;VARTA';
                // }
                // http://localhost:6060/api/cms/wires?page=0&size=50&sort=timestamp,desc&search=,agency:Varta;Bhasha;VARTA,source!pulse
                url += ',source!pulse';
                break;
            case 'affiliateFeed':
                if (this.enabledAffiliateFeeds && this.enabledAffiliateFeeds.length === 0) {
                    url += ',agency:affiliate';
                }
                else {
                    url += ',agency:';
                    for (var i = 0; i < this.enabledAffiliateFeeds.length; i++) {
                        url += this.enabledAffiliateFeeds[i] + ';';
                    }
                    url = url.slice(0, -1);
                }
                url += ',source!pulse';
                break;
        }
        this.callFail = false;
        if (this.initialUrl === '') {
            this.initialUrl = url;
        }
        this.latestUrl = url;
        this.timings['firstGet'] = performance.now();
        console.log('firstGet => ', performance.now() - this.timings.getMeta);
        console.log('url :: ', url);
        console.log('metadata', this.metaDataUrl);
        this.restService.http_get(url)
            .subscribe(data => {
            this.timings.resp = performance.now();
            console.log('response received => ', performance.now() - this.timings['firstGet']);
            this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
            this.totalRecords = data['totalElements'];
            if (this.pageId === 'competetionData') {
                this.totalRecords = data['totalPages'];
            }
            this.callFail = false;
            this.topFunction();
            this.measureTime(0);
            callback(data);
        });
    }
    getDomainName(item) {
        let domains = JSON.parse(localStorage.getItem(StaticDataService.allDomains));
        for (let i of domains) {
            if (i['id'] === item.domainId) {
                return i['name'];
            }
        }
        return '--';
    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        if (document.getElementsByClassName('contentList') && document.getElementsByClassName('contentList').length > 0) {
            document.getElementsByClassName('contentList')[0].scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
    }
    arrayOne(n) {
        return Array(n);
    }
    onPageNumberChange(pagenum) {
        this.pageNum = pagenum;
        this.searchResults(this.str, this.pageNum, this.dataInsertion);
    }
    onPageSizeChange(size) {
        this.pageNum = 0;
        this.pageSize = size;
        this.searchResults(this.str, this.pageNum, this.dataInsertion);
    }
    toggleSwitch(model) {
        if (model === 'exact') {
            this.exactMatch = !this.exactMatch;
            this.searchResults(this.str, this.pageNum, this.dataInsertion);
        }
    }
    callToggles(ev, model) {
        const key = ev.keyCode || ev.charCode;
        if (key === 13) {
            ev.preventDefault();
            this.toggleSwitch(model);
            ev.stopPropagation();
        }
    }
    getFilterData(facet_name) {
        if (this.facets && this.facets[facet_name]) {
            if (facet_name === 'twitterHandle' || facet_name === 'domains') {
                let facet = {};
                this.facets[facet_name].forEach(e => {
                    facet[e] = e;
                });
                return facet;
            }
            else {
                return this.facets[facet_name];
            }
        }
        else {
            return null;
        }
    }
    urlUpdate(ev) {
        let myArray = ev.data.split(":");
        if (ev.type == 'domainId') {
            if (this.pageId == 'storyFeed') {
                if (myArray != '' && myArray[1] && !myArray[1].includes(";")) {
                    this.restService.http_get(this.metaDataUrl + "?tennant=" + myArray[1])
                        .subscribe(data => {
                        this.facets = data;
                    });
                }
            }
        }
        if (ev.type == 'startTime') {
            ev.data = ev.data.replace(/startTime</g, "endTime<");
        }
        if (ev.type == 'domainId' && myArray != '' && myArray[1] && myArray[1].includes(";")) {
            delete this.filterUrl['metadata.section'];
        }
        else if (ev.type == 'domainId' && myArray == '') {
            delete this.filterUrl['metadata.section'];
        }
        this.filterUrl[ev.type] = ev.data;
        this.pageNum = 0;
        this.searchResults(this.str, this.pageNum, this.dataInsertion);
    }
    checkFocusInside(elem) {
        return (elem && elem.contains(document.activeElement));
    }
    getFullDate(seconds) {
        if (seconds) {
            const date = new Date(seconds);
            return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear() + ', ' +
                ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
                + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
        }
        else {
            return 'not present';
        }
    }
    getFullDateDay(seconds) {
        if (seconds) {
            const date = new Date(seconds);
            return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate();
        }
        else {
            return 'not present';
        }
    }
    getNewTypeDateDay(datestring) {
        if (datestring) {
            if (typeof datestring === 'string') {
                const dt = new Date(datestring.replace('+0000', 'Z'));
                return this.getFullDateDay(Math.round(dt.getTime()));
            }
            else {
                return this.getFullDateDay(datestring);
            }
        }
        else {
            return 'not present';
        }
    }
    getNewTypeDate(datestring) {
        if (datestring) {
            if (typeof datestring === 'string') {
                const dt = new Date(datestring.replace('+0000', 'Z'));
                return this.getFullDate(Math.round(dt.getTime()));
            }
            else {
                return this.getFullDate(datestring);
            }
        }
        else {
            return 'not present';
        }
    }
    getNewTypeDateYear(dateString) {
        if (dateString) {
            if (typeof dateString === 'string') {
                const dt = new Date(dateString.replace('+0000', 'Z'));
                const date = new Date(Math.round(dt.getTime()));
                return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear();
            }
            else {
                const date = new Date(dateString);
                return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear();
            }
        }
        else {
            return 'not present';
        }
    }
    measureTime(count) {
        if (this.listData && this.listData['length'] === this.pageSize) {
            this.timings.list = performance.now();
            console.log('list loaded => ', performance.now() - this.timings.resp);
            console.log('total first load time => ', performance.now() - this.timings.constr);
        }
        else if (count < 6) {
            setTimeout(e => {
                this.measureTime(++count);
            }, 0);
        }
    }
    checkIfOnePublished(items) {
        return (items.wirePublishedStories
            .filter(e => e.metadata && e.metadata.status && e.metadata.status === 'PUBLISHED').length > 0);
    }
    checkDomain(items) {
        return (items.wirePublishedStories
            .filter(e => e.domainId === this.domain).length > 0);
    }
    openPickPhotoStory(item, aiPhotoStory) {
        if (aiPhotoStory) {
            item.story[0].listImages.forEach(res => {
                if (res.images && res.images.length > 0) {
                    res.caption = res.images[res.index].caption;
                    res.credit = res.images[res.index].credit;
                    res.description = res.images[res.index].description;
                    res.src = res.images[res.index].src;
                    res.title = res.images[res.index].title;
                }
            });
        }
        let eventCategory = 'Feeds';
        let eventAction = sessionStorage.getItem(StaticDataService.tenantName) + ' ' + this.setFeedsName + ' Pick as story';
        let eventLabel = '';
        let eventValue = null;
        this.googleAnalytics(eventCategory, eventAction, eventLabel, eventValue);
        const _a = this.sharedService.getConfig(true), { timeout, closeOnClick } = _a, config = tslib_1.__rest(_a, ["timeout", "closeOnClick"]);
        this.snotify.confirm('Are you sure you want to pick story?', '', Object.assign({}, config, { buttons: [
                {
                    text: 'Yes', action: (toast) => {
                        this.pickPhotoGallery(item);
                        this.showLoader = true;
                        this.snotify.remove(toast.id);
                        this.googleAnalytics("Skippable Alerts", "Are you sure you want to pick story?", sessionStorage.getItem(StaticDataService.tenantName) + ' ' + 'Yes', null);
                    }, bold: false
                },
                {
                    text: 'No', action: (toast) => {
                        this.snotify.remove(toast.id);
                        this.googleAnalytics("Skippable Alerts", "Are you sure you want to pick story?", sessionStorage.getItem(StaticDataService.tenantName) + ' ' + 'No', null);
                    }
                }
            ] }));
    }
    openPickWebStory(item, isWebstory) {
        item.story[0].listImages.forEach(res => {
            if (res.images && res.images.length > 0) {
                res.caption = res.images[res.index].caption;
                res.credit = res.images[res.index].credit;
                res.description = res.images[res.index].description;
                res.src = res.images[res.index].src;
                res.title = res.images[res.index].title;
            }
        });
        let eventCategory = 'Feeds';
        let eventAction = sessionStorage.getItem(StaticDataService.tenantName) + ' ' + this.setFeedsName + ' Pick as story';
        let eventLabel = '';
        let eventValue = null;
        this.googleAnalytics(eventCategory, eventAction, eventLabel, eventValue);
        const _a = this.sharedService.getConfig(true), { timeout, closeOnClick } = _a, config = tslib_1.__rest(_a, ["timeout", "closeOnClick"]);
        this.snotify.confirm('Are you sure you want to pick as web story?', '', Object.assign({}, config, { buttons: [
                {
                    text: 'Yes', action: (toast) => {
                        this.pickWebStory(item, isWebstory);
                        this.snotify.remove(toast.id);
                        this.googleAnalytics("Skippable Alerts", "Are you sure you want to pick story?", sessionStorage.getItem(StaticDataService.tenantName) + ' ' + 'Yes', null);
                    }, bold: false
                },
                {
                    text: 'No', action: (toast) => {
                        this.snotify.remove(toast.id);
                        this.googleAnalytics("Skippable Alerts", "Are you sure you want to pick story?", sessionStorage.getItem(StaticDataService.tenantName) + ' ' + 'No', null);
                    }
                }
            ] }));
    }
    openPickAsTranslatedStory(item) {
        let chosenData, headline, summary;
        if (this.translationType === 'original') {
            chosenData = this.originalData;
            headline = this.pickedHeadline;
            summary = this.pickedSummary;
        }
        if (this.translationType === 'translated') {
            chosenData = this.translatedData;
            headline = this.translatedHeadline;
            summary = this.translatedSummary;
        }
        const url = this.config.get('product').baseUrl + '/api/cms/elements/story/' + this.storyData.id + '?domainFrom='
            + this.storyData.domainId;
        const lead_url = this.config.get('product').baseUrl + '/api/cms/elements/story/leadmedia/' + this.storyData.id + '?domainFrom='
            + this.storyData.domainId;
        this.showLoader = true;
        this.snowplowAnalytics(('/dash/story/new?refId=' + this.storyData.id), 'pick as story');
        if (this.translationType === 'translated') {
            this.restService.http_post(url, chosenData, data => this.setDatatoGetPickedAsStory(data, headline, summary, chosenData, lead_url));
        }
        else {
            this.restService.http_get(url)
                .subscribe(data => this.setDatatoGetPickedAsStory(data, headline, summary, chosenData, lead_url), error => this.showerror(error));
        }
    }
    showerror(error) {
        this.showLoader = false;
        this.snotify.error('Story could not be loaded', '', this.sharedService.getConfig(false));
        this.router.navigate(['/dash/wire']);
    }
    setDatatoGetPickedAsStory(data, headline, summary, chosenData, lead_url) {
        this.showLoader = false;
        this.restService.http_get(lead_url).subscribe(leadId => {
            localStorage.setItem(this.storyData.id, JSON.stringify({
                'story': JSON.stringify(this.storyData),
                'elements': data,
                'leadElement': leadId,
                'elementData': JSON.stringify(chosenData),
                'domain': this.storyData.domainId,
                'headline': headline,
                'summary': summary,
                'source': 'translationFeed',
                'translated': this.translationType,
                'selectedService': this.selectedService
            }));
            setTimeout(e2 => {
                window.open(window.location.origin + '/dash/story/new?refId=' + this.storyData.id + '&domain='
                    + this.domain + '&type=story', '_blank');
                this.showLoader = false;
            }, 70);
        });
    }
    pickPhotoGallery(item) {
        if (this.pageId === 'LHphotogalleryFeed') {
            console.log(item);
            const url = this.config.get('product').baseUrl + '/api/cms/elements/photoStory';
            this.restService.http_post(url, item, data => {
                if (data && data != null && !data.hasOwnProperty('error')) {
                    this.restService.http_post(this.config.get('product').baseUrl
                        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.all_element_api), data, res => {
                        if (res && res != null && !res.hasOwnProperty('error') && (res.length == data.length)) {
                            let elements = {};
                            res.forEach(e => {
                                elements[e.id] = e;
                            });
                            localStorage.setItem(item.nid, JSON.stringify({
                                'story': JSON.stringify(item),
                                'originalData': JSON.stringify(item),
                                'elements': data,
                                'source': 'LHphotogalleryfeed',
                                'elementsData': JSON.stringify(elements)
                            }));
                            window.open(window.location.origin + '/dash/story/new?refId=' + item.nid + '&domain=' + this.domain + '&type=gallery', "_blank");
                        }
                        else {
                            this.snotify.error('Story elements could not be loaded', '', this.sharedService.getConfig(false));
                        }
                        this.showLoader = false;
                    });
                }
                else {
                    this.showLoader = false;
                    this.snotify.error('Story could not be loaded', '', this.sharedService.getConfig(false));
                    this.router.navigate(['/dash/wire']);
                }
                // setTimeout(e2 => {
                //   this.showLoader = false;
                //   // window.open(window.location.origin + '/dash/story/new?refId=' + item.nid + '&domain=' + this.domain + '&type=gallery',"_self");
                //   window.open(window.location.origin + '/dash/story/new?refId=' + item.nid + '&domain=' + this.domain + '&type=gallery', "_blank");
                //   this.showLoader = false;
                // }, 70);
            });
        }
        else if (this.pageId === 'photogalleryFeed') {
            const url = this.config.get('product').baseUrl + '/api/cms/elements/story/' + item.id + '?domainFrom=' + item.domainId;
            this.showLoader = true;
            this.snowplowAnalytics(('/dash/story/new?refId=' + item.id), 'pick as story');
            this.restService.http_get(url)
                .subscribe(data => {
                if (data && data != null && !data.hasOwnProperty('error')) {
                    this.restService.http_post(this.config.get('product').baseUrl
                        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.all_element_api), data, res => {
                        if (res && res != null && !res.hasOwnProperty('error') && (res.length == data.length)) {
                            let elements = {};
                            res.forEach(e => {
                                elements[e.id] = e;
                            });
                            localStorage.setItem(item.id, JSON.stringify({
                                'story': JSON.stringify(item),
                                'elements': data,
                                'originalData': JSON.stringify(item),
                                'source': 'photogalleryfeed',
                                'elementsData': JSON.stringify(elements)
                            }));
                            window.open(window.location.origin + '/dash/story/new?refId=' + item.id + '&domain=' + this.domain + '&type=gallery', "_blank");
                        }
                        else {
                            this.snotify.error('Story elements could not be loaded', '', this.sharedService.getConfig(false));
                        }
                        this.showLoader = false;
                    });
                }
                else {
                    this.showLoader = false;
                    this.snotify.error('Story could not be loaded', '', this.sharedService.getConfig(false));
                    this.router.navigate(['/dash/wire']);
                }
            }, error => {
                // console.log(error);
                this.showLoader = false;
                this.snotify.error('Story could not be loaded', '', this.sharedService.getConfig(false));
                this.router.navigate(['/dash/wire']);
            });
            // setTimeout(e2 => {
            //   window.open(window.location.origin + '/dash/story/new?refId=' + item.id + '&domain=' + this.domain + '&type=gallery', "_blank");
            //   this.showLoader = false;
            // }, 70);
        }
        else if (this.pageId === 'storyFeed') {
            console.log(item.leadMedia);
            const url = this.config.get('product').baseUrl + '/api/cms/copy/elements/story/' + item.id + '?domainFrom=' + item.domainId;
            this.showLoader = true;
            this.snowplowAnalytics(('/dash/story/new?refId=' + item.id), 'pick as story');
            this.restService.http_get(url)
                .subscribe(data => {
                this.showLoader = false;
                if (data.leadMedia && data.leadMedia.elements && data.leadMedia.elements.length > 0) {
                    item.leadMedia = data.leadMedia;
                    console.log('updated item', item.leadMedia);
                }
                let jsonData = {
                    'story': JSON.stringify(item),
                    'elements': data.elements,
                    'originalData': JSON.stringify(item),
                    'source': 'storyFeed'
                };
                // if(item.leadMedia && item.leadMedia.image && item.leadMedia.image.images){
                //   jsonData['images']=JSON.stringify(item.leadMedia.image.images)
                // }else{
                //   jsonData['images']=JSON.stringify('');
                // }
                console.log('jsonData=======>', jsonData);
                console.log('resData=======>', data);
                localStorage.setItem(`${item.id}`, JSON.stringify(jsonData));
                setTimeout(e2 => {
                    window.open(window.location.origin + '/dash/story/new?refId=' + item.id + '&domain=' + this.domain + "&type=story", "_blank");
                    this.showLoader = false;
                }, 70);
            }, error => {
                // console.log(error);
                this.showLoader = false;
                this.snotify.error('Story could not be loaded', '', this.sharedService.getConfig(false));
                this.router.navigate(['/dash/wire']);
            });
        }
        else if (this.pageId === 'AIgalleryFeed') {
            let index = 0;
            let inQueue = 0;
            let eleList = [];
            let elementsData = {};
            let elements = [];
            this.snotify.info('Picking AI gallery feed...', '', this.sharedService.getConfig(false));
            for (let image of item.story[0].listImages) {
                eleList.push({ id: null, caption: image.caption });
                let imagePath = this.wireImageDisplayUrl + item.location + '/' + image.src;
                const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
                defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                const fd = new FormData();
                fd.set('file', imagePath);
                ++inQueue;
                this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd).
                    subscribe(res => {
                    console.log(res);
                    if (defaultImagecardData && res && !res.hasOwnProperty('error')) {
                        console.log("HERE", res);
                        defaultImagecardData.id = null;
                        defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
                        defaultImagecardData.image.images['original'] = res['images']['original'];
                        defaultImagecardData.image.caption = image.caption ? image.caption : '';
                        this.snotify.success('Uploaded image - ' + (index + 1) + ' of ' + item.story[0].listImages.length, '', this.sharedService.getConfig(false));
                        index++;
                        this.restService.http_post(this.config.get('product').baseUrl
                            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'), defaultImagecardData, result => {
                            inQueue--;
                            eleList[eleList.map(function (e) { return e.caption; }).indexOf(result.image.caption)].id = result.id;
                            if (inQueue < 1) {
                                console.log(eleList);
                                for (let ele of eleList) {
                                    elements.push(ele.id);
                                }
                                this.restService.http_post(this.config.get('product').baseUrl
                                    + this.config.getEndPoint(this.config.get('views'), this.page_id, this.all_element_api), elements, res1 => {
                                    if (res1 && res1 != null && !res.hasOwnProperty('error') && (res1.length == elements.length)) {
                                        res1.forEach(e => {
                                            elementsData[e.id] = e;
                                        });
                                        localStorage.setItem(item.id, JSON.stringify({
                                            'story': JSON.stringify(item),
                                            // 'originalData': JSON.stringify(item),
                                            'elements': elements,
                                            'source': 'AIgalleryfeed',
                                            'elementsData': JSON.stringify(elementsData)
                                        }));
                                        window.open(window.location.origin + '/dash/story/new?refId=' + item.id + '&domain=' + this.domain + '&type=gallery', "_blank");
                                        this.showLoader = false;
                                    }
                                });
                            }
                        });
                    }
                    else {
                        inQueue--;
                        console.log("ERROR COMING");
                        this.snotify.error('Failed to upload an Image!', '', this.sharedService.getConfig(false));
                    }
                }, (error) => {
                    inQueue--;
                    this.snotify.error('Failed to upload an Image!', '', this.sharedService.getConfig(false));
                    if (inQueue < 1) {
                        localStorage.setItem(item.id, JSON.stringify({
                            'story': JSON.stringify(item),
                            // 'originalData': JSON.stringify(item),
                            'elements': elements,
                            'source': 'AIgalleryfeed',
                            'elementsData': JSON.stringify(elementsData)
                        }));
                        setTimeout(() => {
                            window.open(window.location.origin + '/dash/story/new?refId=' + item.id + '&domain=' + this.domain + '&type=gallery', "_blank");
                        }, 3000);
                        this.showLoader = false;
                    }
                });
            }
            // const url = this.config.get('product').baseUrl + '/api/cms/elements/photoStory';
            // this.restService.http_post(url, item, data => {
            //   if(data && data != null && !data.hasOwnProperty('error'))
            //     {
            //       this.restService.http_post(this.config.get('product').baseUrl
            //       + this.config.getEndPoint(this.config.get('views'), this.page_id, this.all_element_api),
            //       data,
            //       res => {
            //         if (res && res != null && !res.hasOwnProperty('error') && (res.length == data.length)) {
            //           let elements = {};
            //           res.forEach(e => {
            //             elements[e.id] = e;
            //           })
            //         }else{
            //           this.snotify.error('Story elements could not be loaded', '', this.sharedService.getConfig(false));
            //         }
            // this.showLoader = false;
            //       });
            //     }
            //     else{
            //       this.showLoader = false;
            //       this.snotify.error('Story could not be loaded', '', this.sharedService.getConfig(false));
            //       this.router.navigate(['/dash/wire']);
            //     }
            //   // setTimeout(e2 => {
            //   //   this.showLoader = false;
            //   //   // window.open(window.location.origin + '/dash/story/new?refId=' + item.nid + '&domain=' + this.domain + '&type=gallery',"_self");
            //   //   window.open(window.location.origin + '/dash/story/new?refId=' + item.nid + '&domain=' + this.domain + '&type=gallery', "_blank");
            //   //   this.showLoader = false;
            //   // }, 70);
            // });
        }
    }
    pickWebStory(item, isWebstory) {
        localStorage.setItem(item.id, JSON.stringify(item));
        if (isWebstory) {
            localStorage.setItem("WebstoryId", item.id);
            window.open(window.location.origin + '/dash/story/new?webStoryId=' + item.id + '&domain=' + this.domain + '&type=web-story');
            // window.location.href = window.location.origin+'/dash/story/new?webStoryId='+ item.id + '&domain=' + this.domain + '&type=web-story';
        }
        else {
            localStorage.setItem("AIWebStoryId", item.id);
            localStorage.setItem("AIsource", "AIWebStoryfeed");
            window.open(window.location.origin + '/dash/story/new?AIid=' + item.id + '&domain=' + this.domain + '&type=web-story', "_blank");
        }
        // window.location.href = window.location.origin + '/dash/story/new?AIid=' + item.id + '&domain=' + this.domain + '&type=web-story';
    }
    openStoryEdit(item, language) {
        console.log("access: " + this.accessDenied);
        let eventCategory = 'Feeds';
        let eventAction = sessionStorage.getItem(StaticDataService.tenantName) + ' ' + this.setFeedsName + ' Pick as story';
        let eventLabel = '';
        let eventValue = null;
        this.googleAnalytics(eventCategory, eventAction, eventLabel, eventValue);
        const url = this.wireGetUrl + '/' + item.id + '?domain=' + this.domain;
        const images = [];
        let key = null;
        if (item && item.story[0] && item.story[0].images && item.story[0].images.length > 0) {
            key = 'images';
            for (const image of item.story[0].images) {
                images.push(this.wireImageUrl + item.location + '/' + image);
            }
        }
        if (item && item.story[0] && item.story[0].listImages && item.story[0].listImages.length > 0) {
            key = 'listImages';
            for (const image of item.story[0].listImages) {
                if (this.pageId === 'currentEconomistFeed' || this.pageId === 'archivedEconomistFeed' || this.pageId === 'wsjFeed') {
                    images.push({
                        'url': this.wireImageUrl + image.src,
                        'caption': image.caption
                    });
                }
                else {
                    images.push({
                        'url': this.wireImageUrl + item.location + '/' + image.src,
                        'caption': image.caption
                    });
                }
            }
        }
        this.showLoader = true;
        this.snowplowAnalytics(('/dash/story/new?refId=' + item.id), 'pick as story');
        this.restService.http_get(url)
            .subscribe(data => {
            data.targetLanguage = language;
            this.mapStoryObject(data, (story, paraContent) => {
                const wireId = String(story.wireFeedId).replace(' ', '');
                if (localStorage.getItem(wireId) !== null) {
                    localStorage.removeItem(wireId);
                }
                // localStorage.setItem('pageId',this.pageId);
                localStorage.setItem(wireId, JSON.stringify({
                    'story': JSON.stringify(story),
                    'para': paraContent,
                    'images': JSON.stringify(images),
                    'key': key,
                    'originalData': JSON.stringify(data),
                    'source': (this.pageId === 'agencyFeed' || this.pageId === 'hindiFeed' ||
                        this.pageId == 'currentEconomistFeed' || this.pageId == 'archivedEconomistFeed'
                        || this.pageId == 'printEconomistFeed' || this.pageId == 'wsjFeed') ? 'AGENCY' : 'PRINT',
                }));
                setTimeout(e2 => {
                    window.open(window.location.origin + '/dash/story/new?refId=' + wireId + '&domain=' + this.domain, "_blank");
                    this.showLoader = false;
                }, 70);
            });
        }, error => {
            // console.log(error);
            this.showLoader = false;
            this.snotify.error('Story could not be loaded', '', this.sharedService.getConfig(false));
            this.router.navigate(['/dash/wire']);
        });
    }
    mapStoryObject(dataObj, callback) {
        let paraContent = '';
        const story = JSON.parse(JSON.stringify(StaticDataService.defaultStoryData));
        console.log(story);
        console.log(dataObj);
        let domainName = environment.domainBaseUrls.filter(e => e.id === sessionStorage.getItem(StaticDataService.domainLiteral))[0]['name'];
        if (dataObj) {
            if (dataObj.story && dataObj.story !== null && dataObj.story.length > 0) {
                paraContent = dataObj.story[0]['content'] ? dataObj.story[0]['content'] : null;
                story.summary = dataObj.story[0].summary ? dataObj.story[0].summary.trim() : '';
                story.metadata.authors = dataObj.story[0].author ? dataObj.story[0].author.split(',') : null;
            }
            else {
                paraContent = null;
                story.summary = '';
                story.metadata.authors = null;
            }
            story.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            story.wireFeedId = dataObj.id ? dataObj.id : null;
            story.mobileHeadline = dataObj.headline ? dataObj.headline : null;
            story.metadata.agency = (dataObj.agency && dataObj.agency !== 'mint_print') ? dataObj.agency : null;
            if ((this.pageId == 'currentEconomistFeed' || this.pageId == 'archivedEconomistFeed' || this.pageId == 'printEconomistFeed') && domainName == "HT NEW") {
                story.metadata.agency = "The Economist";
            }
        }
        setTimeout(e => {
            callback(story, paraContent);
        }, 100);
    }
    snowplowAnalytics(url, name) {
        switch (this.pageId) {
            case 'agencyFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Agency Feed', [], name);
                break;
            case 'photogalleryFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Photo Gallery Feed', [], name);
                break;
            case 'webStoryFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Web Story Feed', [], name);
                break;
            case 'storyFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Story Feed', [], name);
            case 'translationFeedHT':
                this.sharedService.analyticsCall((window.location.origin + url), 'HT Translated Stories Feed', [], name);
                break;
            case 'translationFeedLM':
                this.sharedService.analyticsCall((window.location.origin + url), 'LM Translated Stories Feed', [], name);
                break;
            case 'translationFeedBangla':
                this.sharedService.analyticsCall((window.location.origin + url), 'Bangla Translated Stories Feed', [], name);
                break;
            case 'translationFeedTamil':
                this.sharedService.analyticsCall((window.location.origin + url), 'Tamil Translated Stories Feed', [], name);
                break;
            case 'translationFeedTelegu':
                this.sharedService.analyticsCall((window.location.origin + url), 'Telegu Translated Stories Feed', [], name);
                break;
            case 'translationFeedMarathi':
                this.sharedService.analyticsCall((window.location.origin + url), 'Marathi Translated Stories Feed', [], name);
                break;
            case 'translationFeedKannada':
                this.sharedService.analyticsCall((window.location.origin + url), 'Kannada Translated Stories Feed', [], name);
                break;
            case 'LHphotogalleryFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Photo Gallery Feed', [], name);
                break;
            case 'AIgalleryFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'AI Photo Gallery Feed', [], name);
                break;
            case 'printFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Print Feed', [], name);
                break;
            case 'currentEconomistFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Economist Feed', [], name);
                break;
            case 'archivedEconomistFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Economist Feed', [], name);
                break;
            case 'printEconomistFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Economist Feed', [], name);
                break;
            case 'wsjFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'WSJ Feed', [], name);
                break;
            case 'competitionFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Competition Feed', [], name);
                break;
            case 'hindiFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Hindi Feed', [], name);
                break;
            case 'webstoryFeed':
                this.sharedService.analyticsCall((window.location.origin + url), 'Web Story Feed', [], name);
                break;
        }
    }
    openPreview(item) {
        this.isAccessDenied();
        let eventCategory = 'Feeds';
        let eventAction = sessionStorage.getItem(StaticDataService.tenantName) + ' ' + this.setFeedsName + ' Preview as story';
        let eventLabel = '';
        let eventValue = null;
        this.googleAnalytics(eventCategory, eventAction, eventLabel, eventValue);
        this.snowplowAnalytics(('/dash/story/new?refId=' + item.id), 'preview story');
        if (this.pageId === 'competetionData') {
            this.openCompetetionPreview = true;
            this.wireContent = this.sanitizer.bypassSecurityTrustHtml(item);
        }
        else {
            this.openWirePreview = true;
            this.wireContent = this.sanitizer.bypassSecurityTrustHtml(item.story[0].content);
        }
        this.wirePreviewStory = item;
        this.sharedService.overflowhidden();
    }
    openVideoCovertorPopupFun(item, type) {
        this.logoUrl = '',
            this.audioUrl = '';
        this.openVideoCovertorPopup = true;
        this.videoConvertorReqBody.content = {};
        this.videoConvertorReqBody.storyId = item.id;
        this.videoConvertorReqBody.domainId = item.domainId;
        this.restService.http_post(this.config.get('product').baseUrl
            + '/api/cms/element/get-all-by-ids/', item.elements, result => {
            result.forEach(e => {
                let url = '';
                let caption = '';
                if (type === 'web-story') {
                    url = e && e.image && e.image.images && e.image.images['900x1600'] ? e.image.images['900x1600'] : '';
                    caption = e.webStorySlide && e.webStorySlide[0] ? e.webStorySlide[0].text : '';
                }
                else {
                    url = e && e.image && e.image.images && e.image.images['1600x900'] ? e.image.images['1600x900'] : '';
                    caption = '';
                }
                if (url) {
                    this.videoConvertorReqBody.content[url] = caption;
                }
            });
            console.log("videoConvertorReqBody", this.videoConvertorReqBody);
        }),
            err => {
                this.snotify.error('Image fetching failed', '', this.sharedService.getConfig(false));
            };
        this.restService.http_get(this.config.get('product').baseUrl
            + '/api/cms/audio?type=BACKGROUND').subscribe(res => {
            this.audioList = res;
        });
        this.restService.http_get(this.config.get('product').baseUrl
            + '/api/cms/images?type=LOGO').subscribe(res => {
            this.logoList = res;
        });
    }
    convertToVideo() {
        this.restService.http_post(this.config.get('product').videoCmsUrl
            + '/api/cms/video/create/imagevideo', this.videoConvertorReqBody, result => {
            if (!result.hasOwnProperty('error')) {
                this.closeVideoConvertorPopup();
                this.getDefaultList(0, this.dataInsertion);
            }
        });
    }
    closeVideoConvertorPopup() {
        this.openVideoCovertorPopup = false;
    }
    openTwitterPreview(item) {
        this.trustedHTML = '';
        this.openTwitterWirePreview = true;
        this.wirePreviewStory = item;
        this.trustedHTML = this.makeRenderable(this.sharedService.escToText(item.embeddedCode));
        this.sharedService.runEmbedProcessor(item.embeddedCode, this.embedElement);
    }
    makeRenderable(text) {
        return this.sanitizer.bypassSecurityTrustHtml(text);
    }
    openPhotoGalleryPreview(item) {
        this.isAccessDenied();
        this.openPhotoGalleryView = true;
        this.photoGalleryData = item;
        console.log(item.elements);
        let eventCategory = 'Feeds';
        let eventAction = sessionStorage.getItem(StaticDataService.tenantName) + ' ' + this.setFeedsName + ' Preview as story';
        let eventLabel = '';
        let eventValue = null;
        this.googleAnalytics(eventCategory, eventAction, eventLabel, eventValue);
        this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), this.page_id, this.all_element_api), item.elements, res => {
            // console.log(this.storyData.elements);
            this.photoGalleryData.imageData = res;
            console.log(this.photoGalleryData);
        });
    }
    openWebstoryPreview(item) {
        this.openWebstoryView = true;
        this.webstoryData = item;
        console.log(this.webstoryData);
        let eventCategory = 'Feeds';
        let eventAction = sessionStorage.getItem(StaticDataService.tenantName) + ' ' + this.setFeedsName + ' Preview as story';
        let eventLabel = '';
        let eventValue = null;
        this.googleAnalytics(eventCategory, eventAction, eventLabel, eventValue);
        this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), this.page_id, this.all_element_api), item.elements, res => {
            // this.photoGalleryData.imageData = res;
            // console.log(this.photoGalleryData)
        });
        if (this.webstoryData && this.webstoryData['metadata'] &&
            this.webstoryData['metadata']['canonicalUrl'] && this.webstoryData['metadata']['canonicalUrl'] != null)
            this.webstoryPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.webstoryData['metadata']['canonicalUrl']);
    }
    openStoryFeedPreview(item) {
        console.log('item', item);
        this.openStoryFeedView = true;
        this.feedsStoryData = item;
        console.log(item.elements);
        let eventCategory = 'Feeds';
        let eventAction = sessionStorage.getItem(StaticDataService.tenantName) + ' ' + this.setFeedsName + ' Preview as story';
        let eventLabel = '';
        let eventValue = null;
        this.googleAnalytics(eventCategory, eventAction, eventLabel, eventValue);
        this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), this.page_id, this.all_element_api), item.elements, res => {
            // console.log(this.storyData.elements);
            this.feedsStoryData.imageData = res;
            console.log(this.feedsStoryData);
        });
    }
    clickTab(type) {
        this.translationType = type;
    }
    openTranslationPreview(item) {
        this.isAccessDenied();
        this.openTranslationView = true;
        this.translationType = 'original';
        this.storyData = item;
        console.log(item);
        let eventCategory = 'Feeds';
        let eventAction = sessionStorage.getItem(StaticDataService.tenantName) + ' ' + this.setFeedsName + ' Preview as story';
        let eventLabel = '';
        let eventValue = null;
        // this.wireContent = this.sanitizer.bypassSecurityTrustHtml(item.story[0].content);
        this.googleAnalytics(eventCategory, eventAction, eventLabel, eventValue);
        this.pickedHeadline = this.storyData.mobileHeadline ? this.storyData.mobileHeadline : '';
        this.pickedSummary = this.storyData.summary ? this.storyData.summary : '';
        if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['feeds'] && this.domainConfig['config']['feeds'][this.pageId]) {
            this.selectedService = this.domainConfig['config']['feeds'][this.pageId];
        }
        this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), this.page_id, this.all_element_api), item.elements, res => {
            this.originalData = res;
            this.translatedData = JSON.parse(JSON.stringify(res));
            console.log("orig ====>", this.originalData);
            this.restService.http_post(this.config.get('product').baseUrl + '/api/cms/story/translate/' + item.id + '?selectedService=' + this.selectedService, null, trans => {
                if (trans && trans.translation) {
                    let i = 0;
                    this.translatedHeadline = trans.headline ? trans.headline : '';
                    this.translatedSummary = trans.summary ? trans.summary : '';
                    for (let j in this.translatedData) {
                        if (i < trans.translation.length) {
                            if (this.translatedData[j].type === 'paragraph') {
                                this.translatedData[j].paragraph.body = trans.translation[i].translatedText;
                                i++;
                            }
                        }
                    }
                }
                else {
                    this.snotify.error('Translation API failed', '', this.sharedService.getConfig(false));
                }
                // console.log("trans ====>",this.translatedData)
            });
        });
    }
    openLHPhotoGalleryPreview(item) {
        this.isAccessDenied();
        this.openLHPhotoGalleryView = true;
        this.photoGalleryData = item;
        console.log(this.photoGalleryData);
        let eventCategory = 'Feeds';
        let eventAction = sessionStorage.getItem(StaticDataService.tenantName) + ' ' + this.setFeedsName + ' Preview as story';
        let eventLabel = '';
        let eventValue = null;
        this.googleAnalytics(eventCategory, eventAction, eventLabel, eventValue);
    }
    openAIGalleryPreview(item) {
        this.isAccessDenied();
        this.openAIGalleryView = true;
        this.photoGalleryData = item;
        this.photoGalleryData.story[0].listImages.forEach(res => {
            if (res.images && res.images.length > 0) {
                res['index'] = 0;
            }
        });
        console.log(this.photoGalleryData);
        let eventCategory = 'Feeds';
        let eventAction = sessionStorage.getItem(StaticDataService.tenantName) + ' ' + this.setFeedsName + ' Preview as story';
        let eventLabel = '';
        let eventValue = null;
        this.googleAnalytics(eventCategory, eventAction, eventLabel, eventValue);
    }
    closePreview() {
        this.openWirePreview = false;
        this.openCompetetionPreview = false;
        this.wirePreviewStory = null;
        this.openPhotoGalleryView = false;
        this.openTranslationView = false;
        this.openLHPhotoGalleryView = false;
        this.openAIGalleryView = false;
        this.openStoryFeedView = false;
        this.openWebstoryView = false;
        this.sharedService.overflowauto();
    }
    updateCopyCounter(item) {
        const dataObj = item;
        dataObj.copyCounter += 1;
        this.restService.http_put(this.wirePutUrl + '/' + dataObj.id, dataObj, res => { });
    }
    open_new(id) {
        console.log(id);
        window.open(window.location.origin + '/dash/story/' + id, '_blank');
    }
    pdfDocumentLoaded(event) {
        const pdfEl = document.getElementsByTagName('ng2-pdfjs-viewer');
        if (pdfEl) {
            for (let j = 0; j < pdfEl.length; j++) {
                const iframeEl = pdfEl[j].getElementsByTagName('iframe')[0];
                if (iframeEl && iframeEl.contentDocument.getElementsByClassName('page')[0]) {
                    const height = iframeEl.contentDocument.getElementsByClassName('page')[0].clientHeight;
                    const containerEl = document.getElementsByClassName('container')[0].children;
                    for (let i = 0; i < containerEl.length; i++) {
                        containerEl[i].getElementsByClassName('dataField')[0].setAttribute('style', 'height:' + height + 'px;');
                    }
                }
            }
        }
    }
    openUrl(item) {
        // console.log(item);
        const url = item.story[0].content;
        this.snowplowAnalytics('http://www.dereferer.org/?' + url, 'link click');
        window.open('http://www.dereferer.org/?' + url, '_blank');
    }
    openUrlforData(item) {
        window.open(item, '_blank');
    }
    ngOnDestroy() {
        if (this.stompClient && this.stompClient.connected) {
            this.stompClient.disconnect();
        }
    }
    googleAnalytics(eventCategory, eventAction, eventLabel, eventValue) {
        this.gaService.gaEventView(eventCategory, eventAction, eventLabel, eventValue);
    }
    openPreviewVideo(item) {
        this.trustedHTML = '';
        this.openVideoPopup = true;
        this.trustedHTML = item.aiVideoUrl;
    }
    downloadVideo(item) {
        if (item.aiVideoUrl) {
            let fileName = item.aiVideoUrl.substring(item.aiVideoUrl.lastIndexOf('/') + 1, item.aiVideoUrl.length);
            saveAs(item.aiVideoUrl, fileName);
        }
        else {
            this.snotify.error('Video URL not found', '', this.sharedService.getConfig(false));
        }
    }
    closeVideoPopup() {
        this.openVideoPopup = false;
    }
    navigateToFrontendStory(story) {
        console.log(story);
        if (story && story.metadata.url && story.metadata.url.trim() !== '') {
            if (story.metadata.url.substring(0, 4) === 'http') {
                window.open(story.metadata.url, "_blank");
            }
            else {
                if (this.sharedService.currentDomainUrl === null || this.sharedService.currentDomainUrl === undefined || this.sharedService.currentDomainUrl.trim() === '') {
                    let obj = environment.domainBaseUrls.filter(e => e.id === sessionStorage.getItem(StaticDataService.domainLiteral));
                    if (obj) {
                        window.open(obj[0].baseUrl + story.metadata.url, "_blank");
                    }
                }
                else {
                    window.open(this.sharedService.currentDomainUrl + story.metadata.url, "_blank");
                }
            }
        }
    }
    isAccessDenied() {
        const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
        const restrictedStoriesObj = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].story;
        let userRestrictedStoryTypes = [];
        if (restrictedStoriesObj && restrictedStoriesObj.length > 0) {
            for (let item of restrictedStoriesObj) {
                if (item) {
                    userRestrictedStoryTypes.push(item.name);
                }
            }
        }
        if (userRestrictedStoryTypes && userRestrictedStoryTypes.length > 0 && !(userRestrictedStoryTypes.includes('story'))) {
            this.accessDenied = true;
        }
        if (userRestrictedStoryTypes && userRestrictedStoryTypes.length > 0 && !(userRestrictedStoryTypes.includes('gallery'))) {
            this.galleryAccessDenied = true;
        }
    }
}
